import { Brand } from '../types';
import { Icon } from './Icon';
import { SmallIcon } from './SmallIcon';
import { Theme } from './Theme';

export const AxerealTheme: Brand = {
  Theme,
  SmallIcon,
  Icon,
};
